
let TestModel = require('@/mixins/Forms/2022/TestModel')

module.exports = {

    mixins: [TestModel],

    data(){
        return {
            construction_inspection: {
                name: `A. Construction Inspection (NA7.6.4.1)`,
                questions: {
                    question_1: {
                        id: `1`,
                        question: `The construction documents specify which lighting systems shall have their maximum light output or maximum power draw set to no greater than 85 percent of full light output or full power draw.`,
                        code_reference: `NA7.6.4.1(a)`,
                        answer: false,
                    },
                    question_2: {
                        id: `2`,
                        question: `The controls or the methods of controlling the maximum output of luminaires is such that the maximum light output of the controlled lighting system can be limited, and that normal operation of the controlled lighting does not override the maximum light output.`,
                        code_reference: `NA7.6.4.1(b)`,
                        answer: false
                    },
                    question_3: {
                        id: `3`,
                        question: `The controls are not readily accessible to unauthorized personnel.`,
                        code_reference: `NA7.6.4.1(c), Section 140.6(a)2Jii, Section 170.2(e)2Bxb`,
                        answer: false
                    },
                },
                result: false,
            }
        }
    },

    mounted() {
        this.form = new Form({
            construction_inspection: this.construction_inspection,
            functional_test: this.functional_test,
            comments: '',
            testResult: false,
        }, false)
        this.loadFormData();
    },

    methods: {

        initTest() {

            if (!this.testIsReady) {
                return;
            }

            this.constructionInspectionEvaluation();
            this.functionalTestEvaluation();

            this.form.testResult = (this.form.construction_inspection.result && this.form.functional_test.result);
        },

        constructionInspectionEvaluation() {
            this.form.construction_inspection.result = true;
            _.each(this.form.construction_inspection.questions, (question, i) => {
                if (!question.answer) {
                    this.form.construction_inspection.result = false;
                }
            })
        },

        functionalTestEvaluation() {
            // Needs to be called from the test component.
        },

        loadFormData() {
            // console.log(this.data);
            if(this.data == null){
                return;
            }

            _.each(this.data.construction_inspection.questions, (question, i) => {
                this.form.construction_inspection.questions[i].answer = question.answer;
            })

            _.each(this.data.functional_test.rows, (row, i) => {
                if (!row.isText) {
                    this.form.functional_test.rows[i].answer = row.answer
                }
            })

            this.form.comments = this.data.comments;
        },
    },
}
